CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Login = require 'models/login'
_ = require 'underscore'

module.exports = class LoginList extends CollectionWithHelpers
  model: Login

  initialize: ->
    @listenTo @, 'change:primary', @resetPrimary

  resetPrimary: (login) ->
    # If this isn't an event from a login declaring itself the primary, we
    # ignore it.
    return if !login.get('primary')

    # Otherwise unset all other models.
    for login in @without(login)
      login.set('primary', false)
    @sort()

  comparator: (login) ->
    # We want to show primary first, so a value of true would be 0 and would
    # always come before a value of 1. This is concatenated to the id to sort
    # the rest by creation date.
    Number(!login.get('primary')) + login.id

  types: ->
    _.countBy(_.flatten(@pluck('types')))



// WEBPACK FOOTER //
// ./app/scripts/models/collections/login-list.coffee